"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useWebChatUIContext = _interopRequireDefault(require("./useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useInternalMarkdownIt() {
  return (0, _useWebChatUIContext.default)().internalMarkdownItState;
}

var _default = useInternalMarkdownIt;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VJbnRlcm5hbE1hcmtkb3duSXQiLCJ1c2VXZWJDaGF0VUlDb250ZXh0IiwiaW50ZXJuYWxNYXJrZG93bkl0U3RhdGUiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VJbnRlcm5hbE1hcmtkb3duSXQuanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVdlYkNoYXRVSUNvbnRleHQgZnJvbSAnLi91c2VXZWJDaGF0VUlDb250ZXh0JztcblxuZnVuY3Rpb24gdXNlSW50ZXJuYWxNYXJrZG93bkl0KCkge1xuICByZXR1cm4gdXNlV2ViQ2hhdFVJQ29udGV4dCgpLmludGVybmFsTWFya2Rvd25JdFN0YXRlO1xufVxuXG5leHBvcnQgZGVmYXVsdCB1c2VJbnRlcm5hbE1hcmtkb3duSXQ7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVBLFNBQVNBLHFCQUFULEdBQWlDO0VBQy9CLE9BQU8sSUFBQUMsNEJBQUEsSUFBc0JDLHVCQUE3QjtBQUNEOztlQUVjRixxQiJ9